import { createStore } from 'satcheljs';
import type { FavoritePrivateDistributionListData } from 'owa-favorites-types';

type ViewMode = 'create' | 'edit' | 'closed';

interface PdlEditorStore {
    currentState: ViewMode;
    currentPdl: FavoritePrivateDistributionListData;
}

const defaultStoreData: PdlEditorStore = {
    currentState: 'closed',
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,5): Type 'null' is not assignable to type 'FavoritePrivateDistributionListData'.
    // @ts-expect-error
    currentPdl: null,
};

const store = createStore<PdlEditorStore>('pdlEditorModal', defaultStoreData)();
export default store;
export const getStore = () => store;
